import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=8bf962c6&scoped=true&lang=pug&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"
import style0 from "./Network.vue?vue&type=style&index=0&id=8bf962c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf962c6",
  null
  
)

export default component.exports